<style>
  #dashboard .no-border-bottom{
    border-bottom: none
  }

  #dashboard .card > .card-header{
    font-size: 1.3em;
    font-weight: 500;
  }

  #dashboard .card-body .list-group-item:first-child{
    border-top-left-radius: 0;
    border-top-right-radius: 0;
  }

  #dashboard .card-body > table th:first-child,
  #dashboard .card-body > table td:first-child{
    padding-left: 1.3rem;
  }

  #dashboard .card-header .nav-tabs .nav-link {
    padding: 0.5rem 2rem;
    color: #73818f;
    border-top: 1px;
    text-transform: uppercase;
  }

  #dashboard .card-header .nav-tabs .nav-link {
    padding: 0.5rem 2rem;
    color: #73818f;
  }

  #dashboard .card-header .nav-tabs .nav-link.active {
    border-top: 1px solid #c8ced3 !important;
  }

  #dashboard .card-label{
    text-transform: uppercase;
    letter-spacing: 0.07em;
    font-weight: 500;
    font-size: 1.03em;
    color: rgb(36, 163, 202);
    color: #777
  }

  #dashboard .list-group-item h3{
    font-size: 1.6em;
  }

  #dashboard .summary-card{
    position: relative;
    border-radius: 8px;
    border: 2px solid #20acdd;
    border: none;
    overflow: hidden;
    background-color: #fafeff;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.2),
      3px 3px 1px rgb(104, 186, 216);
    background-color: white;
  }

  #dashboard .summary-card:before{
    content: "";
    position: absolute;
    right: -55%;
    top: 40%;
    width: 109%;
    height: 190%;
    border-radius: 166px;
    transform: rotate(30deg);
    background-color: #f7fdff;
    background-size: 90px;
    background-image: url('~@/assets/images/dashboard-pattern.png');
  }

  #dashboard .summary-card .list-group-item{
    padding: 1.75rem;
    border: none;
    background: transparent
  }

  #dashboard .summary-card .card-label{
    letter-spacing: 0.018em;
    font-size: 1.45em;
    margin-bottom: 1.2em;
    text-transform: none;
    color: #19414d;
  }

  #dashboard .summary-card .list-group-item h3{
    font-size: 2.35em;
    margin-bottom: 0.5em;
  }

  #dashboard .summary-card .list-group-item h3 small{
    font-size: 0.55em;
  }

  #dashboard th{
    text-transform: uppercase;
    letter-spacing: 0.09em;
    color: #888;
    font-size: 0.9em;
  }

  .graph-card .card-header{
    position: relative;
    height: 51px;
    position: relative;
    z-index: 1;
  }

  .graph-card .card-header button{
    margin-top: -4px;
    line-height: 1.3;
  }

  .graph-card .card-body{
    overflow: hidden;
  }
</style>

<template>
  <div>
    <Loader v-if="fetchingDashboardData" />

    <template v-else>
      <div id="dashboard" class="animated fadeIn">
        <div class="row mb-2">
          <div class="col-lg-4 col-md-6 mb-2">
            <div class="card summary-card mb-4">
              <div class="card-body p-0">
                <b-list-group>
                  <b-list-group-item>
                    <small class="card-label d-block mt-1">No. of Finlink Users</small>
                    <h3 class="mt-2">
                      {{ dashboardData ? dashboardData.totalUsers : '0' }}
                    </h3>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-2">
            <div class="card summary-card mb-4">
              <div class="card-body p-0">
                <b-list-group>
                  <b-list-group-item>
                    <small class="card-label d-block mt-1">No. of Accounts</small>
                    <h3 class="mt-2">
                      {{ dashboardData ? dashboardData.totalAccounts : '0' }}
                    </h3>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-2">
            <div class="card summary-card">
              <div class="card-body p-0">
                <b-list-group>
                  <b-list-group-item>
                    <small class="card-label d-block mt-1">
                      No. of Loan Applications
                    </small>
                    <h3 class="mt-2">
                      {{ dashboardData ? parseInt(dashboardData.totalLoanApplications).toLocaleString() : '0' }}
                    </h3>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-2">
            <div class="card summary-card">
              <div class="card-body p-0">
                <b-list-group>
                  <b-list-group-item>
                    <small class="card-label d-block mt-1">Total Investment Amount</small>
                    <h3 class="mt-2">
                      <small>TZS</small>
                      {{ dashboardData ? parseInt(dashboardData.totalInvestments).toLocaleString() : '0' }}
                    </h3>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6 mb-2">
            <div class="card summary-card">
              <div class="card-body p-0">
                <b-list-group>
                  <b-list-group-item>
                    <small class="card-label d-block mt-1">Total Loans Disbursed</small>
                    <h3 class="mt-2">
                      {{ dashboardData ? parseInt(dashboardData.totalLoanDisbursed).toLocaleString() : '0' }}
                    </h3>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2">
          <div class="col-lg-4 col-md-6">
            <div class="card">
              <div class="card-header no-border-bottom">
                Cash at bank <small>( as of 31st January 2020 )</small>
              </div>
              <div class="card-body p-0">
                <b-list-group>
                  <b-list-group-item>
                    <small class="card-label d-inline-block mt-1">
                      Bank
                    </small>
                    <h3 class="mt-2">
                      <small style="font-size: 0.7em">TZS</small>
                      0
                    </h3>
                  </b-list-group-item>
                  <b-list-group-item>
                    <small class="card-label d-inline-block mt-1">
                      Collection Accounts
                    </small>
                    <h3 class="mt-2">
                      <small style="font-size: 0.7em">TZS</small>
                      0
                    </h3>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>
          
          <div class="col-lg-4 col-md-6">
            <div class="card">
              <div class="card-header no-border-bottom">
                30 day projections
              </div>
              <div class="card-body p-0">
                <b-list-group>
                  <b-list-group-item>
                    <small class="card-label d-inline-block mt-1">Investments</small>
                    <h3 class="mt-2">
                      <small style="font-size: 0.7em">TZS</small>
                      {{ dashboardData ? parseInt(dashboardData.expectedCollection).toLocaleString() : '0' }}
                    </h3>
                  </b-list-group-item>
                  <b-list-group-item>
                    <small class="card-label d-inline-block mt-1">Loan Repayments</small>
                    <h3 class="mt-2">
                      <small style="font-size: 0.7em">TZS</small>
                      0
                    </h3>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>

          <div class="col-lg-4 col-md-6">
            <div class="card" style="min-height: calc(100% - 1.7em)">
              <div class="card-header no-border-bottom">
                30 days active
              </div>

              <div class="card-body p-0">
                <b-list-group>
                  <b-list-group-item>
                    <div class="d-flex justify-content-between mt-1">
                      <small class="card-label">Finlink Customers</small>
                    </div>
                    <div class="d-flex justify-content-between mt-2">
                      <h3>
                        {{ dashboardData ? dashboardData.monthlyNewUsers : '0' }} <small>new</small>
                      </h3>
                      <h3>
                        {{ dashboardData ? dashboardData.monthlyActiveUsers : '0' }} <small>active</small>
                      </h3>
                    </div>
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-2" style="display:none">
          <div class="col lg-6">
            <div class="row">
              <div class="col-md-4 col-sm-12">
                <div class="card graph-card d-flex flex-direction-column" style="height: calc(100% - 1.5em); overflow: hidden">
                  <div class="card-header">
                    Loan status summary <small>( year to date )</small>
                  </div>
                  <div class="card-body d-flex align-items-center justify-content-center p-0" style="flex: 1">
                    <LoanPercentGraph />
                  </div>
                </div>
              </div>

              <div class="col-lg-8">
                <div class="card graph-card">
                  <div class="card-header d-flex justify-content-between">
                    Loan Disbursment vs Repayment

                    <div>
                      <button :class="['btn', `${loanGraphTimeFrame === 'month' ? 'btn-primary' : 'btn-link'}`]"
                        @click="loanGraphTimeFrame = 'month'">
                        Monthly
                      </button>
                      <button :class="['btn', `${loanGraphTimeFrame === 'year' ? 'btn-primary' : 'btn-link'}`]"
                        @click="loanGraphTimeFrame = 'year' ">
                        Yearly
                      </button>
                    </div>
                  </div>
                  <div class="card-body">
                    <LoanGraph :timeFrame="loanGraphTimeFrame" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-6">
            <div class="card graph-card">
              <div class="card-header d-flex justify-content-between no-border-bottom">
                Loan Summaries

                <b-dropdown id="dropdown-1" :text="loanSummaryFilter + ' '" variant="primary">
                  <b-dropdown-item @click="setLoanSummaryFilter('Year to date')">Year to date</b-dropdown-item>
                  <b-dropdown-item @click="setLoanSummaryFilter('This Month')">This Month</b-dropdown-item>
                </b-dropdown>
              </div>
              <div class="card-body p-0">
                <b-list-group-item>
                  <div class="d-flex justify-content-between mt-1">
                    <small class="card-label">Total Disbursed</small>
                    <small class="card-label">Amount</small>
                  </div>
                  <div class="d-flex justify-content-between mt-2">
                    <h3>
                      0
                    </h3>
                    <h3>
                      <small style="font-size: 0.7em">TZS</small>
                      {{ totalLoansDisbured }}
                    </h3>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="d-flex justify-content-between mt-1">
                    <small class="card-label">Total Repaid</small>
                    <small class="card-label">Amount</small>
                  </div>
                  <div class="d-flex justify-content-between mt-2">
                    <h3>
                      0
                    </h3>
                    <h3>
                      <small style="font-size: 0.7em">TZS</small>
                      {{ totalLoansRepaid }}
                    </h3>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="d-flex justify-content-between mt-1">
                    <small class="card-label">Total Overdue</small>
                    <small class="card-label">Amount</small>
                  </div>
                  <div class="d-flex justify-content-between mt-2">
                    <h3>0</h3>
                    <h3>
                      <small style="font-size: 0.7em">TZS</small>
                      0
                    </h3>
                  </div>
                </b-list-group-item>
                <b-list-group-item>
                  <div class="d-flex justify-content-between mt-1">
                    <small class="card-label">Debt Ageing</small>
                    <small class="card-label">Amount</small>
                  </div>
                  <div class="d-flex justify-content-between mt-2">
                    <h3>0</h3>
                    <h3>
                      <small style="font-size: 0.7em">TZS</small>
                      0
                    </h3>
                  </div>
                </b-list-group-item>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <!-- Intentionally set to fix spacing issue after removing graph -->
          </div>

          <div class="col-lg-6" style="display: none">
            <div class="card graph-card" style="min-height: calc(100% - 1.7em)">
              <div class="card-header d-flex justify-content-between">
                New Finlink Users
                <div>
                  <button :class="['btn', `${userGraphTimeFrame === 'month' ? 'btn-primary' : 'btn-link'}`]"
                    @click="userGraphTimeFrame = 'month'">
                    Monthly
                  </button>
                  <button :class="['btn', `${userGraphTimeFrame === 'year' ? 'btn-primary' : 'btn-link'}`]"
                    @click="userGraphTimeFrame = 'year' ">
                    Yearly
                  </button>
                </div>
              </div>
              <div class="card-body p-0">
                <template v-if="!fetchingDashboardData && dashboardData !== null">
                  <UserGraph
                    caption="New Finlink customers so far this year"
                    :timeFrame="userGraphTimeFrame"
                    :data="newUserData"
                  />
                </template>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card" style="height: calc(100% - 1.5em);">
              <div class="card-header no-border-bottom">
                Pending Loan Requests
              </div>
              <div class="card-body p-0">
                <table class="table table-stripped">
                  <thead>
                    <tr>
                      <th style="border-bottom: 1px">Customer</th>
                      <th style="border-bottom: 1px">Reqest Date</th>
                      <th style="border-bottom: 1px" class="text-center">Amount</th>
                      <th style="border-bottom: 1px" class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="fetchingDashboardLoans || !dashboardLoans || !dashboardLoans.pending.length">
                      <td colspan="4" class="text-center">
                        <Loader :size="90" v-if="fetchingDashboardLoans" />

                        <span v-else-if="!dashboardLoans">
                          Failed to fetch pending loan requests
                        </span>

                        <span class="text-center" v-else>
                          No pending loan requests found
                        </span>
                      </td>
                    </tr>

                    <tr v-else v-for="(loan, index) in dashboardLoans.pending" :key="index">
                      <td class="text-capitalize">
                        {{ loan.applicant.displayName ? loan.applicant.displayName : loan.applicant }}
                      </td>
                      <td>
                        {{ loan.updatedAt }}
                      </td>

                      <td class="text-center">TZS {{ parseInt(loan.amount).toLocaleString() }}</td>
                      
                      <td class="text-center">
                        <button class="btn btn-default">
                          <i class="fa fa-eye"></i> &nbsp;<span>View</span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <div class="col-lg-6">
            <div class="card" style="height: calc(100% - 1.5em);">
              <div class="card-header no-border-bottom">
                Pending Loan Approvals
              </div>
              <div class="card-body p-0">
                <table class="table table-stripped">
                  <thead>
                    <tr>
                      <th style="border-bottom: 1px">Customer</th>
                      <th style="border-bottom: 1px">Review Date</th>
                      <th style="border-bottom: 1px" class="text-center">Amount</th>
                      <th style="border-bottom: 1px" class="text-center">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="fetchingDashboardLoans || !dashboardLoans || !dashboardLoans.pendingApproval.length">
                      <td colspan="4" class="text-center">
                        <Loader :size="90" v-if="fetchingDashboardLoans" />

                        <span v-else-if="!dashboardLoans">
                          Failed to fetch pending loan approvals
                        </span>

                        <span class="text-center" v-else>
                          No pending loan approvals found
                        </span>
                      </td>
                    </tr>
                    
                    <tr v-else v-for="(loan, index) in dashboardLoans.pendingApproval" :key="index">
                      <td class="text-capitalize">
                        {{ loan.applicant.displayName ? loan.applicant.displayName : loan.applicant }}
                      </td>
                      <td>
                        {{ loan.updatedAt }}
                      </td>

                      <td class="text-center">TZS {{ parseInt(loan.amount).toLocaleString() }}</td>
                      
                      <td class="text-center">
                        <button class="btn btn-default">
                          <i class="fa fa-eye"></i> &nbsp;<span>View</span>
                        </button>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
  import { mapState } from 'vuex';
  import UserGraph from './UserGraph';
  import LoanPercentGraph from './LoanPercentGraph';
  import LoanGraph from './LoanGraph';

  export default {
    name: 'dashboard',
    mounted(){
      this.$store.dispatch('getDashboardData');
      this.$store.dispatch('getDashboardLoans');
    },
    data() {
      return {
        loanGraphTimeFrame: "month",
        userGraphTimeFrame: "month",
        loanSummaryFilter: "Year to date"
      }
    },
    methods: {
      setLoanSummaryFilter(filter){
        this.loanSummaryFilter = filter;
      }
    },
    computed: {
      ...mapState([
        'fetchingDashboardData', 'dashboardData',
        'fetchingDashboardLoans', 'dashboardLoans'
      ]),
      totalLoansDisbured: function(){
        const dashboardData = this.dashboardData;
        if(!dashboardData)
          return 0;
        
        if(this.loanSummaryFilter === 'Year to date')
          return parseInt(dashboardData.totalLoanDisbursedThisYear).toLocaleString();
        else
          return parseInt(dashboardData.totalLoanDisbursedThisMonth).toLocaleString();
      },
      totalLoansRepaid: function(){
        const dashboardData = this.dashboardData;
        if(!dashboardData)
          return 0;
        
        if(this.loanSummaryFilter === 'Year to date')
          return parseInt(dashboardData.totalLoanRepaidThisYear).toLocaleString();
        else
          return parseInt(dashboardData.totalLoanRepaidThisMonth).toLocaleString();
      },
      newUserData: function(){
        if(!this.dashboardData)
          return null;

        return {
          month: this.dashboardData.monthlyRegisteredUsers.map(month => {
            const label = Object.keys(month)[0].split(" ")[0];
            const value = Object.values(month)[0];

            return {label, value};
          }),
          year: this.dashboardData.yearly.map(month => {
            const label = Object.keys(month)[0];
            const value = Object.values(month)[0];

            return {label, value};
          })
        }
      }
    },
    components: {
      UserGraph,
      LoanPercentGraph,
      LoanGraph
    }
  }
</script>
